/**
 * Etiqueta visible "Excel" para botones de exportación.
 * translate="no" evita que el traductor del navegador muestre "Sobresalir" u otro texto incorrecto.
 */
export function ExcelExportLabel({ busy = false, busyText = "Generando…" }) {
  return (
    <span className="notranslate" translate="no" lang="en">
      {busy ? busyText : "Excel"}
    </span>
  );
}

/** title / aria-label en español; el texto visible sigue siendo "Excel". */
export const excelExportButtonA11y = {
  title: "Exportar a Excel",
  "aria-label": "Exportar a Excel",
};
